import { combineReducers } from 'redux'
import * as R from 'ramda'
import P from 'helpers/predicates'

import cancelProject from 'containers/Project/CancelProjectDialog/reducer'
import fileRename from 'containers/Project/FileRenameDialog/reducer'
import fileDescriptionRename from 'containers/Project/FileDescriptionRenameDialog/reducer'
import fileUpload from 'containers/Project/FileUploadDialog/reducer'
import {
  supportTeamReducer as supportTeam,
  supportTeamChangeReducer as supportTeamChanges,
} from 'containers/Project/SupportTeam/reducer'
import {
  projectDetailReducer as detail,
  projectWorkflowReducer as workflow,
  projectViewUiReducer as view,

} from 'containers/Project/View/reducer'
import {
  createReducer,
} from 'helpers/ReducerUtil'
import { restrictedUiReducer } from 'containers/Form/Restricted/reducer'
import { projectUpdateReducer } from 'containers/Project/Update/reducer'
import review from 'containers/Project/Review/reducer'
import updateReview from 'containers/Project/UpdateReview/reducer'
import greenlight from 'containers/Project/GreenlightSection/reducer'
import projectExecution from 'containers/Project/ProjectExecutionSection/reducer'
import projectNvqual from 'containers/Project/NvqualSection/reducer'
import projectCpm from 'containers/Project/CpmSection/reducer'
import projectWeeklyUpdates from 'containers/Project/WeeklyUpdateSection/reducer'
import projectNvbugs from 'containers/Project/NvbugsSection/reducer'
import header from 'containers/Project/Header/reducer'
import hierarchies from 'containers/Project/Hierarchies/reducer'
import description from 'containers/Project/Description/reducer'
import thumbnail from 'containers/Project/Thumbnail/reducer'
import projectSchedule from 'containers/Project/ScheduleSection/reducer'
import search from 'containers/Project/ElasticSearch/reducer'
import workflowDetails from 'containers/Project/LifecycleSection/reducer'
import projectAeRegions from 'containers/Project/AERegion/reducer'
import HulkRequest from 'containers/Project/HulkRequest/reducer'

import {
  SET_ISLOADED,
  RESET_ISLOADED,
  FORM_STATUS,
  SET_FORM_STATUS,
  UPDATE_REFERENCES
} from './constants'


const setIsLoaded = (values, action) => {
  return true
}

const resetIsLoaded = (values, action) => {
  return false
}

const setFormStatus = (values, action) => {
  return action.status
}

const updateRevision = (prev, { revisionId }) => P.isNotNil(revisionId)
  ? revisionId
  : prev

const updateReferences = (prev, { refs }) => R.both(P.isNotNil, P.isNotEmpty)
  ? refs
  : prev

const isLoadedReducer = createReducer(false, {
  [SET_ISLOADED]: setIsLoaded,
  [RESET_ISLOADED]: resetIsLoaded,
})

const setFormStatusReducer = createReducer('', {
  [SET_FORM_STATUS]: setFormStatus,
})

const elementReferences = createReducer([], {
  [UPDATE_REFERENCES]: updateReferences
})

const projectReducer = combineReducers({
  elementReferences,
  detail,
  workflow,
  supportTeam,
  isLoaded: isLoadedReducer,
  supportTeamChanges,
  formStatus: setFormStatusReducer,
  update: projectUpdateReducer,
  updateReview,
  review,
  header,
  fileUpload,
  fileRename,
  fileDescriptionRename,
  projectExecution,
  projectSchedule,
  projectNvqual,
  projectCpm,
  projectWeeklyUpdates,
  projectNvbugs,
  greenlight,
  cancelProject,
  search,
  workflowDetails,
  projectAeRegions,
  hierarchies,
  description,
  thumbnail,
  HulkRequest
})

const projectUiReducer = combineReducers({
  view,
  restricted: restrictedUiReducer,
})

export {
  projectReducer,
  projectUiReducer,
}
